var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-wrap input-radio"},[_c('input',_vm._b({staticClass:"is-checkradio is-info",attrs:{"id":_vm.id,"type":"radio"},domProps:{"checked":_vm.shouldBeChecked,"value":_vm.value},on:{"change":_vm.updateInput}},'input',_vm.$attrs,false)),_c('label',{staticClass:"radio",attrs:{"for":_vm.id}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }